import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { clearAlerts, useAlerts } from "./hooks";
import { Typography } from "@mui/material";
var AlertsSnackbar = function (_a) {
    var SnackbarProps = _a.SnackbarProps, AlertProps = _a.AlertProps;
    var alerts = useAlerts(function (state) { return state.alerts; });
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var handleClick = function () {
        setOpen(true);
    };
    var handleClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
        // FIXME: Just temporary clearing all notifications
        // Really each notification should have it's own timeout
        clearAlerts();
    };
    useEffect(function () {
        if (!isEmpty(alerts)) {
            setOpen(true);
        }
    }, [alerts]);
    return (_jsx(Stack, { spacing: 2, sx: { width: "100%" }, children: _jsx(Snackbar, __assign({ open: open, autoHideDuration: 5000, onClose: handleClose, anchorOrigin: { horizontal: "center", vertical: "top" }, sx: {
                boxShadow: "0px 0px 24px 0px rgba(40, 48, 94, 0.12)",
            } }, SnackbarProps, { children: _jsx("div", { children: alerts.map(function (alert, i) { return (_jsx(Alert, __assign({ onClose: handleClose, severity: alert.severity, variant: "filled", sx: {
                        width: "100%",
                        marginBottom: 0.5,
                        color: "#fff",
                    } }, AlertProps, { children: _jsx(Typography, { variant: "body2", sx: { whiteSpace: "pre-wrap" }, children: alert.message }) }), "alert-".concat(i))); }) }) })) }));
};
export default AlertsSnackbar;
